import CouponCard from "./CouponCard";
import ModernDataTable from "../ModernDataTable";
import { useMediaQuery, useTheme } from "@mui/material";

const MiniCoupons = ({couponState, fetchNextPage, reload}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const columns = [
        {
            header: "קוד קופון",
            field: "code",
            align: "right",
            width: "25%"
        },
        {
            header: "חברה",
            field: "company",
            align: "right",
            width: "12%"
        },
        {
            header: "הנחה",
            field: "discount",
            align: "right",
            width: "12%"
        },
        {
            header: "תקופה",
            field: "period",
            align: "right",
            width: "12%"
        },
        {
            header: "תוקף עד",
            field: "expiryDate",
            align: "right",
            width: "10%"
        },
        {
            header: "שימוש",
            field: "usage",
            align: "right",
            width: "10%"
        },
        {
            header: "סטטוס",
            field: "status",
            align: "right",
            width: "10%"
        },
        {
            header: "פעולות",
            field: "actions",
            align: "left",
            width: "9%"
        }
    ];

    return (
        <ModernDataTable
            data={couponState.coupons}
            columns={isMobile ? [] : columns}
            isLoading={couponState.isLoading}
            hasMore={couponState.hasMoreData}
            onLoadMore={fetchNextPage}
            useInfiniteScroll={true}
            hideHeader={isMobile}
            containerSx={{
                margin: { xs: "12px", md: "20px" }
            }}
            tableSx={{
                tableLayout: "fixed",
                width: "100%"
            }}
            emptyStateTitle="אין קופונים"
            emptyStateSubtitle="נסה לשנות את הפילטרים או החיפוש"
        >
            {couponState.coupons.map((coupon, i) => (
                <CouponCard
                    reload={reload}
                    coupon={coupon}
                    key={coupon.id}
                />
            ))}
        </ModernDataTable>
    );
};

export default MiniCoupons;